export const version = "ethers/5.6.1";
//# sourceMappingURL=_version.js.map